module.exports = __webpack_public_path__ + "img/logo.232593f2.png";